module.exports = __webpack_public_path__ + "static/img/card_05@2x.a5229b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_05@2x.png
// module id = 0rgL
// module chunks = 0